import { render, staticRenderFns } from "./CreateSceneFolder.vue?vue&type=template&id=b8d3009a&scoped=true&"
import script from "./CreateSceneFolder.vue?vue&type=script&lang=js&"
export * from "./CreateSceneFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d3009a",
  null
  
)

export default component.exports